const defaultState = {
  data: [],
  isAllNotificationsSeen: false,
  lastSeenAt: null,
  count: 0,
  isLoaded: false
};

const ConfirmationModal = (state = defaultState, action) => {
  switch (action.type) {
    case "ADD_NOTIFICATIONS":
      return {
        ...state,
        data: [...action.notifications],
        count: action.count,
        isAllNotificationsSeen: false,
        isLoaded: true
      };

    case "SHOW_NOTIFICATIONS":
      return {
        ...state,
        isAllNotificationsSeen: true
      };

    case "SET_LAST_SEEN_AT":
      return {
        ...state,
        data: [
          ...state.data.map(notification => ({
            ...notification,
            isSeen: state.lastSeenAt
              ? notification.lastUpdatedAt < state.lastSeenAt
              : notification.lastUpdatedAt < action.lastSeenAt
          }))
        ],
        lastSeenAt: action.date,
        count: action.date ? state.data.filter(({ lastUpdatedAt }) => lastUpdatedAt > action.date).length : 0
      };

    default:
      return state;
  }
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/reducers/Notifications/index.js